"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var clone = require('clone');

var tv4 = require('tv4');

var SEVERITY = require('../../constant/reminder/severity.constant');

var Todo = /*#__PURE__*/function () {
  function Todo(opt) {
    _classCallCheck(this, Todo);

    this.title = null;
    this.description = null;
    this.severity = null;
    this.link = null;
    this.sendDate = null;

    if (opt && opt.details) {
      this.fillObject(clone(opt.details));
    }
  }

  _createClass(Todo, [{
    key: "fillObject",
    value: function fillObject(details) {
      this.title = details.title;
      this.description = details.description || null;
      this.severity = details.severity || SEVERITY.LOW;
      this.link = details.link;
      this.sendDate = details.sendDate ? new Date(details.sendDate) : null;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Todo.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'todo.schema.json',
        type: 'object',
        properties: {
          title: {
            type: 'string'
          },
          description: {
            type: ['string', 'null']
          },
          severity: {
            "enum": Object.keys(SEVERITY)
          },
          link: {
            type: 'string'
          },
          sendDate: {
            type: ['object', 'null']
          }
        },
        required: ['title', 'link', 'description', 'severity']
      };
    }
  }]);

  return Todo;
}();

module.exports = Todo;